  <template>
  <b-modal style="padding:15px" size="md" id="DeleteUserModal" ref="modal" title="Delete User" ok-title="Yes" cancel-title="No" 
      @ok= "handleOk">
        <form ref="DeleteUserForm" @submit.stop.prevent= "handleSubmit">
        
         Are you sure to delete this record ?
           
        </form>
      </b-modal>
      </template>

      <script>
import axios from 'axios';
// import config from '../config.js';

export default {
    name: 'Users',
    data(){
        return{
          moduleName:'Users',
        }  
  },
      props: {
  userId: null,
},
  computed:{
   
   
        
  },
methods:{
    deleteUser(){ 
        console.log(this.$auth.user())
     axios.get('/user/Delete/'+ this.userId)
      .then(res=>{
            if(res.data.status == 1)
            {
                this.$bvModal.msgBoxOk('User deleted successfully!', {
                title: 'Confirmation',
                size: 'sm',
                buttonSize: 'sm',
                okVariant: 'success',
                headerClass: 'p-10 border-bottom-0',
                footerClass: 'p-2 border-top-0',
                centered: true
                });
                 this.$router.go()
            }
        })
        .catch((err) => {
      console.warn('error during http call', err);
     })
    },
  
     
      handleOk(bvModalEvt) {
        // Prevent modal from closing
        bvModalEvt.preventDefault()
        // Trigger submit handler
        this.handleSubmit()
      },
      handleSubmit() {
        // Exit when the form isn't valid
       
        this.deleteUser()
        
        this.$nextTick(() => {
          //this.$router.go('/phones')
          this.$bvModal.hide('DeleteUserModal')
        
        })
      },
 
  
  },
	

}
</script>
